import { createSlice } from "@reduxjs/toolkit";
import { userAuthApi } from "../services/userAuthApi";

const initialState = {
  count: null,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setCount: (state, action) => {
      state.count = action.payload;
    },
    removeCount: (state, action) => {
      state.count = (state.count || 0) - action.payload;
    },
    increaseCount: (state, action) => {
      state.count = (state.count || 0) + action.payload;
    },
  },
});

export const { setCount, removeCount, increaseCount } = chatSlice.actions;

export default chatSlice.reducer;
